export default __webpack_public_path__ + "static/media/other2.58bb9b13.svg";